<template>
    <CCol v-bind="$attrs">
        <ValidationProvider tag="div" :vid="vid" :name="name" v-slot="{ errors }" :rules="rules">
            <CTextarea :placeholder="placeholder" :rows="rows" :description="description" :value="value" @input="changeText" :dir="direction">
                <template #label>
                    <slot :name="label">{{ autoLabel }}</slot>
                    <span v-if="required" class="text-danger">*</span>
                </template>

                <template #invalid-feedback>
                    <span class="invalid-feedback d-block">{{ errors[0] }}</span>
                </template>
                <template v-for="(_, slot) in $slots">
                    <template :slot="slot">
                        <slot :name="slot"></slot>
                    </template>
                </template>
            </CTextarea>
        </ValidationProvider>
    </CCol>
</template>

<script>
import { DefaultInputProps } from './defaultProps'

export default {
    name: 'CCustomTextarea',
    props: {
        ...DefaultInputProps,
        rows: {
            default: 3,
            type: [Number, String],
        }
    },
    computed: {
        direction() {
            if(this.ltr === undefined) {
                return this.$i18n.locale === 'en' ? 'ltr' : 'rtl'
            }

            return this.ltr ? 'ltr' : 'rtl'
        },
        autoLabel() {
            return this.label === '' ? this.name : this.label
        }
    },
    methods: {
        changeText(value) {
            this.$emit('input', value)
        }
    }
}
</script>